import { Link, useParams } from "react-router-dom";

import { useDirectTopupMenuDetail } from "@/api/menus";
import { FreshTile } from "@/components/FreshTile";
import { useT } from "@/lib/i18n";

/**
 * Categories inside one Direct Top-Up menu. Mirrors MenuDetailFresh
 * for the regular catalog: cards with image + name; click goes to
 * /direct-topup/categories/:id (form + denomination picker).
 */
export function DirectTopupMenu() {
  const { id } = useParams<{ id: string }>();
  const menuId = id ? Number(id) : null;
  const detail = useDirectTopupMenuDetail(menuId);
  const t = useT();

  if (detail.isLoading)
    return <div className="text-slate-400">{t("common.loading")}</div>;
  if (detail.isError || !detail.data) {
    return (
      <div className="space-y-3">
        <Link to="/direct-topup" className="text-sm text-accent">
          {"<- " + t("direct_topup.back")}
        </Link>
        <div className="text-sm text-slate-500">
          {String(detail.error) || t("menu.not_found")}
        </div>
      </div>
    );
  }

  const m = detail.data;

  return (
    <div className="space-y-6">
      <div>
        <Link to="/direct-topup" className="text-sm text-accent">
          {"<- " + t("direct_topup.back")}
        </Link>
        <div className="mt-3 flex items-center gap-4">
          {m.image_url && (
            <img
              src={m.image_url}
              alt={m.name}
              className="h-16 w-16 rounded border border-surface-border object-cover"
            />
          )}
          <h1 className="text-2xl font-semibold text-slate-800">{m.name}</h1>
        </div>
      </div>

      {m.categories.length === 0 ? (
        <div className="rounded border border-surface-border bg-surface-muted px-4 py-6 text-center text-sm text-slate-500">
          {t("direct_topup.empty")}
        </div>
      ) : (
        <div className="fresh-tile-grid">
          {m.categories.map((c) => (
            <FreshTile
              key={c.category_id}
              to={`/direct-topup/categories/${c.category_id}`}
              title={c.category_name}
              subtitle={`${c.services_count} ${
                c.services_count === 1
                  ? t("explore.services.one")
                  : t("explore.services.many")
              }`}
              imageUrl={c.image_url}
            />
          ))}
        </div>
      )}
    </div>
  );
}
